// src/components/AdminLayout.js
import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { MdPeople, MdInsights, MdFeedback, MdTune, MdLogout } from 'react-icons/md';
import './AdminLayout.css';

const AdminLayout = ({ children }) => {
    const location = useLocation();
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem('token');
        navigate('/login');
    };

    return (
        <div className="admin-container">
            <nav className="admin-navbar">
                <div className="admin-nav-header">
                    <img src="/logo.svg" alt="SwavAI" className="admin-logo" />
                    <h2>Admin Panel</h2>
                </div>
                <div className="admin-nav-links">
                    <Link to="/admin/users" className={location.pathname === '/admin/users' ? 'active' : ''}>
                        <MdPeople /> <span>Users</span>
                    </Link>
                    <Link to="/admin/analytics" className={location.pathname === '/admin/analytics' ? 'active' : ''}>
                        <MdInsights /> <span>Analytics</span>
                    </Link>
                    <Link to="/admin/feedback" className={location.pathname === '/admin/feedback' ? 'active' : ''}>
                        <MdFeedback /> <span>Feedback</span>
                    </Link>
                    <Link to="/admin/tuner" className={location.pathname === '/admin/tuner' ? 'active' : ''}>
                        <MdTune /> <span>Tuner</span>
                    </Link>
                </div>
                <button onClick={handleLogout} className="admin-logout-button">
                    <MdLogout /> <span>Logout</span>
                </button>
            </nav>
            <main className="admin-content">
                {children}
            </main>
        </div>
    );
};

export default AdminLayout;